export default import.meta.ROLLDOWN_FILE_URL_gBoWR2t1J0zUGcwprkTnww